// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"1efd33da","88":"a816b4b2","204":"b8b6d52e","234":"c042c5d3","588":"6956c7bc","669":"c7340062","787":"b9d09672"}[chunkId] + ".chunk.js";
};